import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlogShellComponent } from '../../blog-shell/blog-shell.component';
import { TranslationSyncService } from '../../../../services/translation-sync.service';
import { BlogEntryBase } from '../../shared/blog-entry-base';

@Component({
  selector: 'app-dark-light-mode',
  standalone: true,
  imports: [BlogShellComponent, CommonModule],
  templateUrl: './dark-light-mode.component.html',
  styleUrls: ['./dark-light-mode.component.css']
})
export class DarkLightModeComponent extends BlogEntryBase {
  constructor(sync: TranslationSyncService) {
    super(sync);
  }
}
